module.exports = require('./helpers/bundle-url').getBundleURL('d4fau') + "logo.7718c6df.svg";